import React, { useState, useEffect, PropsWithChildren } from 'react';
import { useApplicationRights } from "components/hooks/useAppStore"
import { ApplicationRightService, IApplicationRightService } from 'services/ApplicationRightService';

interface ApplicationRightComponentProps {
    requiredApplicationRights: string[];
}
export const ApplicationRightComponent = ({
    children,
    requiredApplicationRights
    }: PropsWithChildren<ApplicationRightComponentProps>) => {

    const applicationRights = useApplicationRights();

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!applicationRights || applicationRights.length === 0) return;
        
        const applicationRightsService: IApplicationRightService = new ApplicationRightService(applicationRights);
        setShow(applicationRightsService.canAccess(requiredApplicationRights));

        }, [applicationRights]);

    return (
        show &&
            children
    )
}
